/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import validationParentsPartenaire from '../validationParentsPartenaire';

/**
 * Étapes « Parents / représentants légaux » : `Steps.ParentsPartenaire1` (5e
 * étape affichée) et `Steps.ParentsPartenaire2` (7e étape affichée).
 *
 * Le `pickBy` de premier niveau est indispensable : `handleErrors` et
 * `AssistantHeader` testent `_.isEmpty(stepErrors)` sans descendre dans l'objet.
 * Retourner `{ parent1: {}, parent2: {} }` marquerait donc l'étape en erreur
 * (croix rouge dans le fil d'étapes, blocage définitif du bouton « Terminer »)
 * alors qu'aucun champ n'est fautif.
 */
const validationStep5et7 = (
  PACS: any,
  numeroPartenaire: number,
  selectedDeclarationType?: string | null,
) => {
  return _.pickBy(
    validationParentsPartenaire(PACS, numeroPartenaire, selectedDeclarationType),
    (value) => !_.isNil(value) && !_.isEmpty(value),
  );
};

export default validationStep5et7;
